export enum ICPCopyTextType {
    Question = 0,
    Helper = 1,
}